import * as R from 'ramda';
import { message } from 'antd';
import { all, select, fork, cancel, race, call, put, take, takeEvery, takeLatest, cancelled } from 'redux-saga/effects';
import { FETCH_VBQL_RESULT } from './vbqlResultsReducer';
import queriesAPI from '../../common/api/queriesAPI';
import entityActions from '../../common/genericActions/entityActions';

export const fetchVBQLResult = function* (action) {
  const connection = yield select(store => (
    store.connection.byId[store.connection['/window'].ids[0]]
  ));

  let result;
  try {
    result = yield call(
      queriesAPI.postQuery,
      connection,
      { vbql: action.payload.query.vbqlStatement },
    );
  } catch (err) {
    message.error('Error fetching schema.');
    yield put(entityActions.receiveErrors(
      action.payload.projectionKey,
      { vbqlResults: R.pathOr([], ['response', 'data', 'errors'], err) },
    ));
  }
  if (result) {
    const vbqlResult = { id: action.payload.projectionKey, ...result };
    yield put(entityActions.receiveEntities(
      action.payload.projectionKey,
      {
        type: 'vbqlResults',
        byId: { [vbqlResult.id]: vbqlResult },
        ids: [vbqlResult.id],
      },
    ));
    return vbqlResult;
  }
  return undefined;
};

export const vbqlResultsWatcher = function* () {
  yield [
    yield takeEvery(
      action => (
        action.type === FETCH_VBQL_RESULT
      ),
      fetchVBQLResult,
    ),
  ];
};

export default {
  vbqlResultsWatcher,
  fetchVBQLResult,
};
